import React from 'react';
import styled from '@emotion/styled';
import { readableColor, rem } from 'polished';
import { css } from '@emotion/react';
import IconSVG from '../../../primitives/IconSVG/IconSVG';
import { colors, spaces } from '../../../core/styles/theme/default';
import { IconSVGProps } from '../../../primitives/IconSVG/IconSVG.interface';

const StyledCardIcons = styled.span(({ emphasized }: any) => {
  const bgColor = emphasized ? 'transparent' : colors.primary300;

  return css`
    display: inline-block;
    padding: ${rem(spaces.delta)} 0 ${rem(spaces.delta)} ${rem(spaces.delta)};
    margin: 0 -${rem(spaces.zeta)} ${rem(spaces.epsilon)} -${rem(spaces.zeta)};
    border-radius: 0 ${rem(4)} ${rem(4)} 0;
    line-height: 0;
    color: ${readableColor(bgColor, colors.primary, colors.white)};
    background: ${bgColor};
    white-space: nowrap;
  `;
});
const StyledIcon = styled(IconSVG)`
  box-sizing: border-box;
  font-size: ${rem(32)};
  margin: 0 ${rem(spaces.delta)};

  &:last-of-type {
    margin-right: ${rem(spaces.epsilon)};
  }
`;

const CardIcons = ({ icons, emphasized }: IconsProps) => {
  return (
    <StyledCardIcons emphasized={emphasized}>
      {icons &&
        icons.map((icon, index) => <StyledIcon {...icon} key={index} />)}
    </StyledCardIcons>
  );
};

export type IconsProps = {
  /** Array with the names of the possible ech icons */
  icons: Array<IconSVGProps>;
  /** optional value to set the icons style to emphasized layout */
  emphasized?: boolean;
};

export default CardIcons;
